/*
  Server websocket endpoint
*/

export const BACKEND_WEBSOCKET_URI =
  (import.meta.env.VITE_APP_BACKEND_WEBSOCKET_URI as string) || 'ws://localhost:12097'

/*
  Interval (ms) for payment waiter checks requests repeating
*/

export const PAYMENT_CHECK_INTERVAL = 5000

/*
  Rooms
*/

export const WS_ROOM_PAYMENT_STATUS_NOTIFICATION =
  'order-payment-status:notification'

/*
  Events
*/

export const WS_EVENT_PAYMENT_STATUS_CHANGED = 'paymentStatusChanged'
